import { render, staticRenderFns } from "./CVGoFurther.vue?vue&type=template&id=6b89a5ad&"
import script from "./CVGoFurther.vue?vue&type=script&lang=ts&"
export * from "./CVGoFurther.vue?vue&type=script&lang=ts&"
import style0 from "./CVGoFurther.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports